module.exports = __webpack_public_path__ + "img/mm_b2_pic3.69ab00e0.png";